import styled from "styled-components"

export const Container = styled.div`
    flex: auto;
    overflow: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;

    .seeMore{
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        font-size: 1.4rem;
        display: flex;
        color: var(--colorFontsCardsDashboard);
        z-index: 101;

        @media (min-width: 960px){
            cursor: pointer;
        }
    }

    .filterContainer{
        position: absolute;
        left: 2.5rem;
        top: 0.7rem;
        font-size: 1rem;
        display: flex;
        color: var(--colorFontsCardsDashboard);
        cursor: pointer;
        z-index: 100;

        .filter{
            display: flex;
            justify-content: center;
            flex-direction: column;
            gap: 0.5rem;

            background: #FFF;
            padding: 1rem;
            box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);
            border-radius: 5px;
            color: #7A05A7;

            input{
                border: 1px solid #7A05A7;
                border-radius: 3px;
                padding: 2px;
            }

            button{
                border-radius: 3px;
                padding: 2px;
                background-color: #7A05A7;
                color: #fff;
                border: 0;
            }
        }
    }
`

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
`

export const Button = styled.div`
     padding: 0.5rem;
    border-radius: 5px;
    background: #2e9699;
    color: #FFF;
    margin: 3rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.loadingButton ? 0.5 : 1};
    pointer-events: ${props => props.loadingButton ? 'none' : 'all'};
    text-align: center;
`